import { FC } from 'react';

import { NbCard, NbPageHeader } from '@/components/Neobrut';

export const Mision: FC = () => {
  return (
    <div className="mx-auto w-full max-w-2xl lg:max-w-3xl pb-10">
      <NbPageHeader
        slug="/ misión"
        title={
          <>
            Una red que<br />
            <span className="nb-highlight">trae a casa.</span>
          </>
        }
        tone="plain"
      />
      <div className="flex flex-col gap-3 px-4 pt-4">
        <NbCard className="p-4">
          <div
            className="text-[10px] font-bold uppercase tracking-[0.08em] opacity-60"
            style={{ fontFamily: '"JetBrains Mono", monospace' }}
          >
            / qué hacemos
          </div>
          <p className="mt-2 text-[14px] leading-relaxed">
            Reconectar mascotas perdidas con sus familias y brindar un espacio accesible para
            quienes encuentran animales en su comunidad.
          </p>
        </NbCard>

        <NbCard className="fill-lost p-4">
          <div
            className="text-[10px] font-bold uppercase tracking-[0.08em] opacity-60"
            style={{ fontFamily: '"JetBrains Mono", monospace' }}
          >
            / cómo
          </div>
          <p className="mt-2 text-[14px] leading-relaxed">
            Creemos que cada animal merece un hogar. Por eso trabajamos en una plataforma
            intuitiva, sencilla y sin fines de lucro que permite publicar y buscar mascotas
            perdidas o encontradas de forma rápida.
          </p>
        </NbCard>

        <NbCard className="fill-solved p-4">
          <div
            className="text-[10px] font-bold uppercase tracking-[0.08em] opacity-60"
            style={{ fontFamily: '"JetBrains Mono", monospace' }}
          >
            / para qué
          </div>
          <p className="mt-2 text-[14px] leading-relaxed">
            Queremos fortalecer el sentido de solidaridad del barrio, promoviendo la empatía, el
            respeto y la responsabilidad hacia los animales. Juntos podemos marcar la diferencia.
          </p>
        </NbCard>
      </div>
    </div>
  );
};
